import { render, staticRenderFns } from "./NetellerSuccess.vue?vue&type=template&id=060aa57e&"
import script from "./NetellerSuccess.vue?vue&type=script&lang=js&"
export * from "./NetellerSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports